import { render } from "./ActiveAccount.vue?vue&type=template&id=107ed890&scoped=true"
import script from "./ActiveAccount.vue?vue&type=script&lang=js"
export * from "./ActiveAccount.vue?vue&type=script&lang=js"

import "./ActiveAccount.vue?vue&type=style&index=0&id=107ed890&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107ed890"]])

export default __exports__